module.exports = __webpack_public_path__ + "assets/img/feature_04.9ccf374a.png";